<div class="container-fluid">
  <mat-tab-group dynamicHeight mat-stretch-tabs>
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon svgIcon="border_color" class="mr-2"></mat-icon>
        Border settings
      </ng-template>
      <div class="row row-gap">
        <div class="row w-100 m-0">
          <div class="col-md-9">
            <mat-checkbox [disableRipple]="true" name="enableBorder" [checked]="!!border.Size" (change)="toggleBorder($event.checked)"
              class="light checkbox">Enable borders
            </mat-checkbox>
          </div>
        </div>

        <div class="row w-100 m-0">
          <div class="col-md-9">
            <h6>Size</h6>
            <div class="row">
              <div class="col-md-10">
                <mat-slider #mySlider min="0" max="10" step="1" class="w-100" [(ngModel)]="border.Size"
                  (input)="border.Size = $event.value" thumbLabel name="borderSize">
                  <input matSliderThumb>
                </mat-slider>
              </div>
              <div class="d-flex justify-content-end align-items-center col-md-2 invisible-border">
                <input type="text" id="Size" class="w-100" min="0" max="10" [value]="border.Size"
                  (input)="onSliderKeyDown($event)" (focusout)="onInputFocusOut($event)">
              </div>
            </div>
          </div>

          <div class="col-md-3">
            <div class="col-md-12 p-0">
              <h6 class="label">Color</h6>
              <ng-container color-picker>
                <app-color-picker [(color)]="border.Color" [position]="'right'" [isInputHidden]="true"
                  [label]="null" [isDisabled]="!border.Size"></app-color-picker>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </mat-tab>
  </mat-tab-group>

  <div class="footer">
    <div class="col-12 d-flex justify-content-end p-0">
      <button matTooltip="Cancel" mat-raised-button type="button" class="mr-3" [mat-dialog-close]="false">
        Cancel
      </button>
      <button matTooltip="Save border settings" mat-raised-button type="button" [mat-dialog-close]="border">
        Save
      </button>
    </div>
  </div>
</div>

